export const getUserCardList = payload => {
  return {
    type: "GET_USER_CARD_LIST",
    payload
  };
};

export const setCardId = payload => {
  return {
    type: "SET_CARD_ID",
    payload
  };
};

export const createCardRegistration = payload => {
  return {
    type: "CREATE_CARD_REGISTRATION",
    payload
  };
};

export const showSpinner = payload => {
  return {
    type: "SHOW_SPINNER",
    payload
  };
};

export const desactivateCard = payload => {
  return {
    type: "DEACTIVATE_CARD",
    payload
  };
};

export const deleteCard = payload => {
  return {
    type: "DELETE_CARD",
    payload
  };
};



// WEBPACK FOOTER //
// ./app/actions/actions/mangoPay.js